module.exports = __webpack_public_path__ + "resources/img/bg_cover_pricing.9feaea755d1632bc74bffff652e3f74d.png";